export default __webpack_public_path__ + "static/pragicts-itops-backup-and-recovery-0c42ca29bd6a49d46d4f2a50e2592135.jpg";